import styled from "styled-components";
import { Modal } from "components/Modal";

export const StrategyShareModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;

    .modal-content {
      width: 100%;
      border-radius: 16px;
      padding: 0;
      overflow: hidden;
      border: none;

      .btn-close,
      .modal-header {
        display: none;
      }

      .modal-body {
        padding: 0;
        margin: 0;
      }
    }
  }

  @media screen and (max-width: 576px) {
    .modal-dialog {
      margin: 1rem auto;
      max-width: 95%;
    }
  }
`;

export const ImageHeader = styled.div`
  position: relative;
  width: 100%;
  height: 173px;

  background: ${(props) => `url(${props.coverImage})`} no-repeat center center,
    lightgray;
  background-size: cover;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;

  padding: 40px 24px 12px 24px;
  gap: 16px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    z-index: 1;
  }

  .strategy-title {
    color: #ffffff;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin: 0;
    z-index: 2;
  }
`;

export const CloseButtonWrapper = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
  backdrop-filter: blur(2px);
`;

export const ModalBodyContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ShareHeading = styled.h3`
  margin: 0;

  color: rgba(10, 13, 18, 0.9);
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
`;

export const SocialButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 28px;

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const SocialShareIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  & > div,
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;

    img,
    svg {
      width: 32px;
      height: 32px;

      stroke: none;
      fill: none;
    }
  }

  span {
    color: rgba(10, 13, 18, 0.7);
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
`;

export const LinkInputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
`;

export const LinkInputPrefix = styled.div`
  flex-shrink: 0;
  padding: 10px 8px;

  color: rgba(10, 13, 18, 0.4);
  font-size: 14px;
  background: #fcfcfc;
  border-right: 1px solid rgba(10, 13, 18, 0.6);
  height: 44px;
  display: flex;
  align-items: center;
`;

export const LinkInputField = styled.input`
  flex-grow: 1;
  border: none;
  outline: none;
  padding: 10px 12px;
  font-size: 14px;
  color: rgba(10, 13, 18, 0.9);
  height: 44px;

  &::placeholder {
    color: rgba(10, 13, 18, 0.4);
  }
`;

export const CopyButton = styled.button`
  display: flex;
  flex-shrink: 0;
  width: 100px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  padding: 10px 14px;
  height: 44px;

  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  outline: none;

  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-radius: 8px;

  border: 2px solid rgba(255, 255, 255, 0.12);
  background: #2258f1;

  box-shadow: 0 2px 2px 0 rgba(255, 255, 255, 0.35) inset,
    0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #1f4ed0;
  }

  &:disabled {
    opacity: 0.8;
    cursor: default;
  }
`;
